/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NewsManagementEditNewsRequest = {
    id: number;
    category?: NewsManagementEditNewsRequest.category;
    title?: string;
    title_en?: string;
    title_cn?: string;
    thumbnail_no?: number;
    is_upload_thumbnails: boolean;
    image_id?: number;
    context?: string;
    context_en?: string;
    context_cn?: string;
    post_date?: string;
    open_status?: NewsManagementEditNewsRequest.open_status;
    release_setting?: NewsManagementEditNewsRequest.release_setting;
};

export namespace NewsManagementEditNewsRequest {

    export enum category {
        NEWS = 'News',
        NO_1KOI = 'No.1Koi',
        STORE_EVENT = 'StoreEvent',
        STORE = 'Store',
        SHOW_WINNERS = 'ShowWinners',
    }

    export enum open_status {
        EDIT = 'edit',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum release_setting {
        NOW = 'now',
        DATE = 'date',
    }


}

